import React from 'react';
import '../../style/icons.css';
import { Icon, Link } from 'arag-ui-lib';
import { PRIMARY, TERTIARY } from '../../helpers/constants';

const DeleteIcon = (props) => {
    const {style, onClick, className, deleteIconTestId, variant } = props;

    return (
        <Link 
            onClick={onClick}
            variant={TERTIARY}
            label={
                <Icon className={(className ? className : 'icon-edit') + ' pull-right'}>
                    <svg 
                        aria-hidden="true" 
                        data-prefix="far" 
                        data-icon="delete"
                        className="svg-inline--fa fa-edit fa-w-18"
                        style={{ fill: variant === PRIMARY ? '#ffd402' :  '#82b0b8'}}  // Using style attribute to ensure priority
                        role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                        <path
                            fill="currentColor"
                            d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"/>
                    </svg>
                </Icon>
            }
            linkTestId={deleteIconTestId ? deleteIconTestId : "delete-icon"}
        />
    )
};

export default DeleteIcon;